import React from 'react';

const rows = [
  ['Issuer file', 'Complete'],
  ['Legal instrument', 'Required'],
  ['Responsible parties', 'Compliance check'],
  ['Evidence vault', 'Documents uploaded'],
  ['Certificate type', 'Secured Note Certificate'],
  ['Transfer policy', 'Approved-only'],
  ['Wallet settlement', 'Pending setup'],
  ['Beneficiary ledger', 'Draft created'],
  ['Compliance check', 'Required before activation'],
];

const tone = (status) => {
  if (status.includes('Complete') || status.includes('uploaded')) return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (status.includes('Required')) return 'bg-amber-50 text-amber-700 border-amber-200';
  if (status.includes('Compliance')) return 'bg-blue-50 text-blue-700 border-blue-200';
  if (status.includes('Pending')) return 'bg-orange-50 text-orange-700 border-orange-200';
  return 'bg-muted text-muted-foreground border-border';
};

const CertificateProgramPreview = () => (
  <section id="program-preview" className="py-20 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14 items-start">
        <div>
          <div className="section-label mb-4">Certificate Program Preview</div>
          <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-foreground">
            Know what is complete, missing, or pending compliance checks.
          </h2>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            Each program should show what is complete, what is missing, and what requires a compliance check before activation.
          </p>
          <p className="mt-4 text-xs text-muted-foreground leading-relaxed">
            Illustrative example — sample statuses, not a real issuer file. Final activation requires compliance checks and complete program files.
          </p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5 lg:p-6 shadow-xl shadow-slate-900/5">
          <div className="flex items-center justify-between gap-4 border-b border-border pb-4 mb-2">
            <div>
              <div className="font-display text-xl font-bold text-foreground">Issuer Certificate File (Example)</div>
              <div className="text-xs text-muted-foreground mt-1">Dashboard-style example preview</div>
            </div>
            <span className="rounded-full bg-primary/10 px-3 py-1 font-mono text-xs text-primary">example preview</span>
          </div>
          <div className="divide-y divide-border">
            {rows.map(([field, status]) => (
              <div key={field} className="grid grid-cols-[1fr_auto] gap-4 py-3 items-center">
                <div className="text-sm font-medium text-foreground">{field}</div>
                <span className={`rounded-full border px-3 py-1 text-[11px] font-mono ${tone(status)}`}>{status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CertificateProgramPreview;
